/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type FC } from 'react';
import type { Option } from '../../../../index';

type InputProps = {
  name: string;
  item: Option;
  value: any;
  disabled?: boolean;
  updateValue: (val: any) => void;
};

const Input: FC<InputProps> = (props) => {
  const { name, item, value, updateValue, disabled } = props;
  const id = name + item.value;

  return (
    <input
      {...{
        type: 'radio',
        name,
        id,
        value: item.value,
        disabled: item.disabled === true || disabled,
        checked: item.value === value,
        onChange: (e) => updateValue(e.target.value),
        tabIndex: -1,
        'aria-label': id,
        ...(item.value === value ? { 'aria-checked': true } : { 'aria-checked': false }),
      }}
    />
  );
};

export default Input;
